import request from '@/utils/request'

export function getList (filters = {}, pagination = {}) {
  return request({
    url: '/external_user',
    method: 'get',
    headers: {
      'X-filters': JSON.stringify(filters),
      'X-pagination': JSON.stringify(pagination)
    }
  })
}

export function getDetail (id) {
  return request({
    url: '/external_user/' + id,
    method: 'get'
  })
}

export function upsert (data) {
  var method = 'post'
  var url = '/external_user'
  if (data.id) {
    method = 'put'
    url = '/external_user/' + data.id
  }
  return request({
    url,
    method,
    data
  })
}

export function remove (id) {
  return request({
    url: '/external_user/' + id,
    method: 'delete',
  })
}
